import React from 'react'
import { createBrowserRouter, RouteObject } from 'react-router-dom';

import { userService } from './services/user';
import { siteService } from './services/site';
import {
  BookingFlowLayout,
  ConfirmBookingBookingLayout,
  ManageBookingLayout,
  ModalLayout,
  Widget
} from './components/layouts';
import { ModalDemo, ProfileDemo } from './components/screens/demo';
import {
  AdditionalDetails,
  BookingConfirmed,
  ConfirmBookingPassThrough,
  Consent,
  CreateBookingPassThrough,
  Initial,
  Payment,
  PersonalDetails,
  PreScreening,
  UnavailableTimeSlot,
  VerificationCode,
  VerificationMethod
} from './components/screens/booking-flow';
import {
  Cancelled,
  NotFoundError as NotFoundManageError,
  UnexpectedError as UnexpectedManageError,
  VerifyShortcode
} from './components/screens/manage-booking';
import { BookWithClinic, BookWithDoctor } from './components/screens/insert';
import {
  AppointmentTypeNotAvailable,
  ApptTypeRequiresF2F,
  PatientNotFound,
  ProviderNoNewPatients,
  ReservedSlotExpired,
  RouteError,
  SessionExpired,
  UnableToSchedAppointment,
  UnexpectedError,
} from './components/screens/error';
import { AutomedManageBooking } from './components/screens/AutomedManageBooking';

const demoRoutes: RouteObject[] = [
  {
    path: "/demo",
    children: [{
      path: 'doctor-modal/',
      element: <ModalDemo modalPath='/doctor/1958/modal' />
    }, {
      path: 'doctor-profile/',
      element: <ProfileDemo iframePath="/doctor/14743/widget" />
    }, {
      path: 'clinic-modal/',
      element: <ModalDemo modalPath='/clinic/2032/modal' />
    }, {
      path: 'clinic-profile/',
      element: <ProfileDemo iframePath="/clinic/2032/widget?afterHours=True" />
      // element: <ProfileDemo iframePath="/clinic/1743/widget?afterHours=True" />
    }]
  }
]

export const router = createBrowserRouter([
  {
    path: "/",
    ErrorBoundary: () => <RouteError />,
    children: [
      {
        index: true,
        loader: () => { throw new Response("Not Found", { status: 404 }); }
      },
      {
        path: 'doctor/:doctorId/',
        children: [{
          path: 'modal/',
          element: <ModalLayout><BookWithDoctor /></ModalLayout>
        }, {
          loader: async ({ params }) => {
            return await userService.GetSitesByUmbracoUser(params.doctorId!);
          },
          path: 'widget/',
          element: <Widget><BookWithDoctor toggleAvailablilty /></Widget>
        }]
      }, {
        path: 'clinic/:clinicId/',
        children: [{
          loader: async ({ params }) => {
            return await siteService.GetSiteByUmbracoId(params.clinicId!);
          },
          path: 'modal/',
          element: <ModalLayout><BookWithClinic /></ModalLayout>
        }, {
          loader: async ({ params }) => {
            return await siteService.GetSiteByUmbracoId(params.clinicId!);
          },
          path: 'widget/',
          element: <Widget><BookWithClinic afterHoursControls toggleAvailablilty /></Widget>
        }]
      }, {
        path: 'app/confirm/',
        element: <ConfirmBookingBookingLayout successPath='/app/confirm/success' />,
        children: [{
          index: true,
          element: <ConfirmBookingPassThrough to="/app/confirm/success" />
        }, {
          path: 'success',
          element: <BookingConfirmed />
        }, {
          path: 'session-expired',
          element: <SessionExpired />
        }]
      }, {
        path: 'app/',
        element: <BookingFlowLayout />,
        errorElement: <BookingFlowLayout />,
        children: [{
          index: true,
          element: <Initial />
        }, {
          path: 'pre-screening/',
          element: <PreScreening />
        }, {
          path: 'personal-details/',
          element: <PersonalDetails />
        }, {
          path: 'verification/',
          children: [{
            index: true,
            element: <VerificationMethod />
          }, {
            path: 'email/',
            element: <VerificationCode codeRequestType='Email' />
          }, {
            path: 'sms/',
            element: <VerificationCode codeRequestType='Mobile' />
          }]
        }, {
          path: 'reserve-booking',
          element: <CreateBookingPassThrough />
        }, {
          path: 'additional-details/',
          element: <AdditionalDetails />
        }, {
          path: 'consent/',
          element: <Consent nextPage='/app/payment' />
        }, {
          path: 'payment/',
          element: <Payment nextPage='/app/confirm' />
        }, {
          path: 'err-appttype-not-available',
          element: <AppointmentTypeNotAvailable />
        }, {
          path: 'err-provider-no-new-patients',
          element: <ProviderNoNewPatients />
        }, {
          path: 'err-appttype-requires-f2f',
          element: <ApptTypeRequiresF2F />
        }, {
          path: 'err-unable-sched-appt',
          element: <UnableToSchedAppointment />
        }, {
          path: 'patient-not-found',
          element: <PatientNotFound />
        }, {
          path: 'unavailable-slottime',
          element: <UnavailableTimeSlot />
        }, {
          path: 'err-unexpected-error',
          element: <UnexpectedError />
        }, {
          path: 'err-reserved-slot-expired',
          element: <ReservedSlotExpired />

        }]
      }, {
        path: 'manage/site/:automedSiteId',
        element: <AutomedManageBooking />
      }, {
        path: 'manage',
        element: <ManageBookingLayout />,
        children: [{
          path: 'error',
          element: <UnexpectedManageError />
        }, {
          path: 'not-found',
          element: <NotFoundManageError />
        }, {
          path: 'cancelled',
          element: <Cancelled />
        }, {
          path: ':siteId/:code',
          element: <VerifyShortcode />
        }]
      },
      ...((import.meta.env.MODE === "development") ? demoRoutes : [])
    ]
  }
]);